import styled from 'styled-components';
import { breakpoints, smaller } from '../../styles/responsive';
import { FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';

export const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  color: 'white',
  justifyContent: 'center',
  alignItems: 'stretch',
  gap: '18px 24px',
  padding: '14px 10px',
  width: '100%'
});

export const Office = styled.div({
  width: 'min(340px, 94vw)',
  display: 'flex',
  justifyContent: 'center',
  [smaller(breakpoints.sm)]: {
    width: '100%'
  }
});

export const OfficeInner = styled.div(({ right }) => ({
  width: 'min(290px, 90vw)',
  margin: '0 auto',
  textAlign: right ? 'right' : 'left',
  padding: '8px 10px',
  borderRadius: 0,
  background: 'transparent',
  border: 'none',
  boxShadow: 'none'
}));

export const Heading = styled.h2({
  fontSize: 'clamp(15px, 0.55vw + 11px, 20px)',
  margin: 0,
  lineHeight: 1.25,
  letterSpacing: 0.1
});

export const OfficeLabel = styled.p({
  fontSize: 'clamp(11px, 0.22vw + 9px, 13px)',
  margin: '0 0 10px',
  opacity: 0.82,
  letterSpacing: 0.2,
  textTransform: 'uppercase'
});

export const InfoRow = styled.div(({ reverse, alignRight }) => ({
  display: 'flex',
  flexDirection: reverse ? 'row-reverse' : 'row',
  justifyContent: alignRight ? 'flex-end' : 'flex-start',
  alignItems: 'flex-start',
  gap: 10,
  margin: '0 0 10px',
  width: '100%'
}));

const iconBase = {
  width: 15,
  height: 15,
  opacity: 0.98,
  marginTop: 2,
  flexShrink: 0,
  color: '#CFEAFF'
};

export const AddressIcon = styled(FaMapMarkerAlt)(iconBase);
export const PhoneIcon = styled(FaPhoneAlt)(iconBase);

export const Address = styled.p({
  fontSize: 'clamp(12px, 0.24vw + 10px, 14px)',
  margin: 0,
  lineHeight: 1.45,
  opacity: 0.95
});

export const Phone = styled.a({
  color: '#D7EEFF',
  fontSize: 'clamp(12px, 0.24vw + 10px, 14px)',
  textDecoration: 'none',
  borderBottom: '1px dashed rgba(215, 238, 255, 0.35)'
});
